import React from 'react'

import clsx from 'clsx'

import ClickoutWrapper from 'components/ClickoutWrapper'
import { useEventContext } from 'context/EventContext'
import isPpcClickOutUrl from 'helpers/isPpcClickOutUrl'

import CtaButtonListing from '../CtaButtonListing'

/** @type {import("./types").default} */
const PricingTrialButton = ({ trialUrl, globalProductId, engagementComponent = 'product_pricing', ...props }) => {
  const eventContext = useEventContext()
  const isClickout = isPpcClickOutUrl(trialUrl)

  return (
    <ClickoutWrapper
      isClickout={isClickout}
      url={trialUrl}
      buyerIntentProductId={globalProductId}
      buyerIntentSourceLocation={`${engagementComponent}:start-trial`}
      buyerIntentTrackAdClick={isClickout}
      className={clsx('PricingTrialButton')}
      {...eventContext.addEvent({
        engagementComponent,
        engagementDestination: 'go-to_vendor-website',
        engagementDetails: 'button_start-trial',
        name: 'engagement_product_clickout',
      })}
    >
      <CtaButtonListing icon={['far', 'external-link']} component="div" {...props}>
        start trial
      </CtaButtonListing>
    </ClickoutWrapper>
  )
}

export default PricingTrialButton
